<div class="consultar-tabela-preco-fin-container">
  <div class="header">
    <h1>Consultar Tabela de Preços</h1>
    <button type="button" class="btn btn-primary" (click)="novo()">
      <i class="fa fa-plus"></i> Adicionar novo
    </button>
  </div>

  <div class="card-box mb-3">
    <div class="row g-3 align-items-end">
      <div class="col-md-4">
        <label class="form-label">Descrição</label>
        <input type="text" class="form-control" [(ngModel)]="filtroDescricao" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Valor</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="filtroValor" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Valor Dollar</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="filtroValorDollar" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Valor Euro</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="filtroValorEuro" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Documento</label>
        <select class="form-control" [(ngModel)]="filtroIdFinDocumento">
          <option [ngValue]="0">Todos</option>
          <option *ngFor="let item of documentos" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>

      <div class="col-md-3">
        <label class="form-label">Início Vigência</label>
        <input type="date" class="form-control" [(ngModel)]="filtroInicioVigencia" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Fim Vigência</label>
        <input type="date" class="form-control" [(ngModel)]="filtroFimVigencia" />
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar
        </button>
        <button type="button" class="btn btn-primary" (click)="buscar()">
          <i class="fa fa-search"></i> Buscar
        </button>
      </div>
    </div>
  </div>

  <div class="card-box">
    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>Descrição</th>
            <th>Valor</th>
            <th>Valor Dollar</th>
            <th>Valor Euro</th>
            <th>Data Cadastro</th>
            <th>Início Vigência</th>
            <th>Fim Vigência</th>
            <th>Documento</th>
            <th style="width: 150px;">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itensPaginados">
            <td>{{ item.descricao }}</td>
            <td>{{ item.valor != null ? item.valor : '-' }}</td>
            <td>{{ item.valorDollar != null ? item.valorDollar : '-' }}</td>
            <td>{{ item.valorEuro != null ? item.valorEuro : '-' }}</td>
            <td>{{ item.dataCadastro }}</td>
            <td>{{ item.inicioVigencia }}</td>
            <td>{{ item.fimVigencia }}</td>
            <td>{{ item.finDocumento || '-' }}</td>
            <td>
              <button type="button" class="btn btn-sm btn-warning me-1" (click)="editar(item)" title="Editar">
                <i class="fa fa-edit"></i>
              </button>
              <button type="button" class="btn btn-sm btn-danger" (click)="deletar(item)" title="Excluir">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="!loading && itens.length === 0">
            <td colspan="9" class="text-center text-muted py-3">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3" *ngIf="itens.length > 0">
      <div class="d-flex align-items-center gap-2">
        <label class="mb-0">Itens por página:</label>
        <select class="form-control form-control-sm per-page" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>

      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">Página {{ paginaAtual }} de {{ totalPaginas }}</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
          Anterior
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="proximaPagina()" [disabled]="paginaAtual >= totalPaginas">
          Próxima
        </button>
      </div>
    </div>
  </div>
</div>
